import { API_URL } from "../config";

/** @returns {string} */
export function getPublicSiteTextsApiPath() {
  return `${API_URL}/api/configuracion/texto-publico`;
}

/** @returns {string} */
export function getLegalTextsApiPath() {
  return `${API_URL}/api/configuracion/textos-legales`;
}
